import { Const } from "const";
import { components, OptionProps, SingleValueProps } from 'react-select';
import SelectDropdown from "./SelectDropdown";


interface SelectDropdownTaskPriorityProps {
  onPriorityChanged: (priority: number | null) => void;
  selectedPriority?: number | null;
  isDisabled: boolean;
}

// same icon + color as the task title list (Const.GetTaskPriorityIconClass); ต่ำ has no icon, the slot keeps labels aligned
const PriorityLabel = ({ value, label }: { value: string, label: string }) => {
  const iconClass = Const.GetTaskPriorityIconClass(Number(value));
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      <span className="task-priority-opt-icon">{iconClass && (<i className={iconClass}></i>)}</span>
      <span>{label}</span>
    </div>
  );
};

const CustomOption = (props: OptionProps<any>) => (
  <components.Option {...props}>
    <PriorityLabel value={props.data.value} label={props.data.label} />
  </components.Option>
);

const CustomSingleValue = (props: SingleValueProps<any>) => (
  <components.SingleValue {...props}>
    <PriorityLabel value={props.data.value} label={props.data.label} />
  </components.SingleValue>
);

// tb_tktask.priority picker - clearing it (x) means "not set" (null)
const SelectDropdownTaskPriority = ({ selectedPriority, onPriorityChanged, isDisabled }: SelectDropdownTaskPriorityProps) => {
  const list = Const.TASK_PRIORITY.map(x => ({ value: x.value.toString(), label: x.label }));

  return (
    <SelectDropdown
      isDisabled={isDisabled}
      list={list}
      onValueChanged={(val) => onPriorityChanged(val == null || val === "" ? null : Number(val))}
      selectedValue={selectedPriority == null ? null : (list.find(e => e.value == selectedPriority.toString()) ?? null)}
      customOption={CustomOption}
      customValue={CustomSingleValue}
      placeholder="ไม่ระบุ"
    />
  )
}

export default SelectDropdownTaskPriority
